<script lang="ts">
  import { ping } from '$lib/api/ping';

  let message = 'hello';
  let result = '';
  let error = '';
  let loading = false;

  async function send() {
    loading = true;
    error = '';
    result = '';
    try {
      const response = await ping({ message });
      result = JSON.stringify(response, null, 2);
    } catch (e) {
      error = e instanceof Error ? e.message : String(e);
    } finally {
      loading = false;
    }
  }
</script>

<section>
  <h2>Ping / Pong</h2>
  <p>Sends an authenticated request to the backend, which echoes it back.</p>

  <div class="row">
    <label for="ping-message">Message</label>
    <input id="ping-message" type="text" bind:value={message} />
    <button on:click={send} disabled={loading}>
      {loading ? 'Sending…' : 'Ping'}
    </button>
  </div>

  {#if result}
    <pre class="ok">{result}</pre>
  {/if}
  {#if error}
    <pre class="err">{error}</pre>
  {/if}
</section>

<style>
  section {
    margin-top: 2rem;
    max-width: 28rem;
    width: 100%;
  }
  .row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  input {
    flex: 1;
    padding: 0.4rem;
  }
  pre {
    text-align: left;
    padding: 0.75rem;
    border-radius: 4px;
    overflow-x: auto;
  }
  .ok {
    background: #f0fff4;
    border: 1px solid #9ae6b4;
  }
  .err {
    background: #fff5f5;
    border: 1px solid #feb2b2;
    color: #c53030;
  }
</style>
